import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import {
  getExperimentVariationKey,
  getExperimentVariables,
} from '@awaze/mfe-common.lib.optimizely'
import { OPTIMIZELY_FLAGS_ENUM } from 'src/constants'
import { OptimizelyData } from 'src/types'

type BannerVariantData = {
  [key in Brand]: {
    [key: string]: {
      primaryTextDefault: string
      primaryTextMobile: string
      secondaryTextDefault: string
      secondaryTextMobile: string
      variant: 'primary' | 'secondary'
      endDate: string
      timeLabelText: {
        days: string
        hours: string
        minutes: string
        seconds: string
      }
    }
  }
}

type AgeCountdownBannerParams = {
  brand: Brand
  language: string
  optimizelyData: OptimizelyData | undefined
}

export const ageCountdownBanner = ({
  brand,
  language,
  optimizelyData,
}: AgeCountdownBannerParams) => {
  if (optimizelyData?.decisions === undefined) {
    return { isIn2693BannerExp: false }
  }

  const countdownBannerExp = getExperimentVariationKey(
    optimizelyData.decisions,
    OPTIMIZELY_FLAGS_ENUM.AGE_COUNTDOWN_BANNER,
  )

  const isIn2693BannerExp = countdownBannerExp === 'variant_a'

  if (!isIn2693BannerExp) {
    return { isIn2693BannerExp: false }
  }

  const bannerVariantData = getExperimentVariables(
    optimizelyData.decisions,
    OPTIMIZELY_FLAGS_ENUM.AGE_COUNTDOWN_BANNER,
  )?.['banner_text'] as BannerVariantData

  if (
    !(brand in bannerVariantData) ||
    !(language in bannerVariantData[brand])
  ) {
    return { isIn2693BannerExp }
  }

  const bannerData = bannerVariantData[brand][language]

  return { isIn2693BannerExp, bannerData }
}
